import React, { useState } from 'react';

import { appendCommentPosition, setCommentCount, updateCommentBox, updateCommentButton, updateCommentReplies } from '../../redux/comments/methods';
import { getCommentReplies, postComment, postCommentPosition } from '../../api/comments';
import { useApplicationState } from '../../hooks/common/use-application-state';
import { saveSelection } from '../../utils/selection-utils';

import styles from './CommentBox.module.scss';

const CommentBox = ({ 
  articleSlug,
}: { 
  articleSlug: any
}) => {
  const [comment, setComment] = useState('');

  const {
    hiddenCommentBox,
    hiddenCommentButton,
    hiddenCommentList,
    positions: commentsPosition,
    comments,
    replies,
    commentButtonPosition,
    selectedRange,
    commentCount,
  } = useApplicationState((state) => ({ 
    positions: state.commentsData.positions,
    comments: state.commentsData.comments,
    replies: state.commentsData.replies,
    hiddenCommentBox: state.commentsData.hiddenCommentBox,
    hiddenCommentList: state.commentsData.hiddenCommentList,
    hiddenCommentButton: state.commentsData.hiddenCommentButton,
    commentButtonPosition: state.commentsData.commentButtonPosition,
    selectedRange: state.commentsData.selectedRange,
    commentCount: state.commentsData.count
  }));

  const handleCommentSubmit = async (e: any) => {
    e.preventDefault();

    if (comment) {
      const payload = {
        content: comment,
        record_type: 'Article',
        record_slug: articleSlug,
        comment_type: "editor"
      }

      if (comments.length && comments[0].id) {
        payload["parent_comment_id"] = comments[0].id
      }
      await postComment(payload).then(async (response) => {
        if (response.success) {
          if (comments.length <= 0) {
            const { data } = response;
            const { anchor, lineNumber, length } = selectedRange;
            await postCommentPosition({
              comment_id: data[0].id,
              anchor,
              length,
              line_number: lineNumber
            }).then((response: { success: any; }) => {
              if (response.success) {
                setCommentCount(commentCount + 1);
                // console.log('response', response);
                // const updatedCommentList = [ ...commentDetails, { id: data[0].id, content: comment, username: data[0].attributes.username }]
                // createComment(updatedCommentList);
                appendCommentPosition({
                  id: Math.random(),
                  type:"comment_position",
                  attributes: {
                    comment_id: Number(data[0].id),
                    line_number: Number(lineNumber),
                    anchor,
                    length
                  }
                })
                // onCommentPositionChange([ ...commentsPosition, {
                //   id: Math.random(),
                //   type:"comment_position",
                //   attributes: {
                //     comment_id: Number(data[0].id),
                //     line_number: Number(lineNumber),
                //     anchor,
                //     length
                //   }
                // }]);
                updateCommentButton(true);
                updateCommentBox(true);
              }
            })
          } else {
            const replyResponse = await getCommentReplies(comments[0].id);
            updateCommentReplies(replyResponse.data)
          }
          setComment('');
        } else {
          // Error Notif
        }
      })
    }
  }

  const handleCommentChange = (e: any) => {
    setComment(e.target.value);
  }

  return (
    <div className={styles.comments_container} hidden={hiddenCommentBox}>
      {comments.length ?
        <div className={styles.comment_list}>
          {comments.map(comment => (
            <div key={comment.id}>
              <span className={styles.username}>{comment.attributes.username}</span> : <span className={styles.content}>{comment.attributes.content}</span>
            </div>
          ))}
          {replies.map(reply => (
            <div className={styles.replies} key={reply.id}>
              <span className={styles.username}>{reply.attributes.username}</span> : <span className={styles.content}>{reply.attributes.content}</span>
            </div>
          ))}
        </div>
        : null}
      <form
        className={styles.comment_box}
        onSubmit={handleCommentSubmit}
      >
        <textarea
          id="commentBox"
          className={styles.text_area}
          placeholder="Add your comment"
          onChange={handleCommentChange}
          value={comment}
        >
        </textarea>
        <button type="submit" className={styles.submit_button}>
          Submit
        </button>
      </form>
    </div>
  );
}

export default CommentBox;
